import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import {
  FaUsers,
  FaClock,
  FaCheckCircle,
  FaExclamationTriangle,
  FaBell,
} from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";

const COLORS = ["#4CAF50", "#FFC107", "#F44336"];

const vendorData = [
  { year: "2021", value: 20 },
  { year: "2022", value: 35 },
  { year: "2023", value: 50 },
  { year: "2024", value: 65 },
];

const orderStatusData = [
  { name: "Completed", value: 60 },
  { name: "Pending", value: 25 },
  { name: "Cancelled", value: 15 },
];

const recentVendors = [
  { vendor: "AHB Corp", category: "Medicine", status: "Pending" },
  { vendor: "XYZ Chemicals", category: "Raw Material", status: "Approved" },
  { vendor: "MediLife Ltd", category: "Equipment", status: "Approved" },
];

const purchaseOrders = [
  { po: "PO1023", vendor: "AHB Pharma", amount: "₹45,000", status: "Pending" },
  {
    po: "PO1022",
    vendor: "XYZ Chemicals",
    amount: "₹30,000",
    status: "Completed",
  },
  {
    po: "PO1021",
    vendor: "MediLife Ltd",
    amount: "₹28,500",
    status: "Cancelled",
  },
];
const topVendorsData = [
  { name: "AHB Pharma", amount: 45000 },
  { name: "XYZ Chemicals", amount: 30000 },
  { name: "MediLife Ltd", amount: 28500 },
  { name: "HealthCorp", amount: 22000 },
  { name: "BioGen", amount: 18000 },
];

export default function Dashboard() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="container-fluid p-4"
      style={{ background: "#f5f7fb", minHeight: "100vh" }}
    >
      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          {/* <h5 className="fw-bold">Welcome back, Shreya!</h5> */}
        </div>

        <div className="text-end">
          <div>{time.toLocaleDateString()}</div>
          <small className="text-muted">{time.toLocaleTimeString()}</small>
        </div>
      </div>

      {/* KPI CARDS */}

      <div className="row g-3 mb-4">
        {/* Total Vendors */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#e8f0fe",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <FaUsers color="#4a7cf3" size={18} />
              </div>

              <div>
                <div className="fw-bold small">Total Vendors</div>
                <div className="fw-bold fs-5">120</div>
              </div>
            </div>
          </div>
        </div>

        {/* Pending Approval */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#fff4e5",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <FaClock color="#f4a100" size={18} />
              </div>

              <div>
                <div className="fw-bold small">Pending Approval</div>
                <div className="fw-bold fs-5">8</div>
              </div>
            </div>
          </div>
        </div>

        {/* Approved Vendors */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#e7f6ec",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <FaCheckCircle color="#34a853" size={18} />
              </div>

              <div>
                <div className="fw-bold small">Approved Vendors</div>
                <div className="fw-bold fs-5">100</div>
              </div>
            </div>
          </div>
        </div>

        {/* Low Stock */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#fdecea",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <FaExclamationTriangle color="#ea4335" size={18} />
              </div>

              <div>
                <div className="fw-bold small">Low Stock Items</div>
                <div className="fw-bold fs-5">6</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* KPI CARDS - ROW 2 */}

      <div className="row g-3 mb-4">
        {/* Total Purchase Orders */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#e3f2fd",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                📄
              </div>

              <div>
                <div className="fw-bold small">Total Orders</div>
                <div className="fw-bold fs-5">85</div>
              </div>
            </div>
          </div>
        </div>

        {/* Pending Orders */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#fff8e1",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                ⏳
              </div>

              <div>
                <div className="fw-bold small">Pending Orders</div>
                <div className="fw-bold fs-5">10</div>
              </div>
            </div>
          </div>
        </div>

        {/* Available Stock */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#e8f5e9",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                📦
              </div>

              <div>
                <div className="fw-bold small">Available Stock</div>
                <div className="fw-bold fs-5">657</div>
              </div>
            </div>
          </div>
        </div>

        {/* Blocked Vendors */}
        <div className="col-md-3">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  background: "#fdecea",
                  width: "45px",
                  height: "45px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                🚫
              </div>

              <div>
                <div className="fw-bold small">Blocked Vendors</div>
                <div className="fw-bold fs-5">7</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CHARTS */}

      <div className="row g-3 mb-4">
        {/* Vendor Growth */}

        <div className="col-md-4">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              <h6 className="fw-bold mb-3">Vendor Growth</h6>

              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={vendorData}>
                  <XAxis dataKey="year" />
                  <YAxis />
                  <Tooltip />

                  <Bar
                    dataKey="value"
                    fill="#4a7cf3"
                    radius={[6, 6, 0, 0]}
                    barSize={35}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* Purchase Order Status */}

        <div className="col-md-4">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              <h6 className="fw-bold mb-3">Purchase Order Status</h6>

              <div className="d-flex align-items-center justify-content-between">
                {/* Donut Chart */}

                <div style={{ position: "relative", width: 150, height: 150 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={orderStatusData}
                        dataKey="value"
                        innerRadius={45}
                        outerRadius={65}
                        paddingAngle={2}
                      >
                        {orderStatusData.map((entry, index) => (
                          <Cell key={index} fill={COLORS[index]} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>

                  {/* Center Text */}

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    60%
                  </div>
                </div>

                {/* Legend */}

                <div>
                  <div className="mb-2 fw-semibold">
                    <span
                      style={{
                        display: "inline-block",
                        width: 10,
                        height: 10,
                        background: "#4CAF50",
                        borderRadius: "50%",
                        marginRight: 8,
                      }}
                    ></span>
                    Completed
                  </div>

                  <div className="mb-2 fw-semibold">
                    <span
                      style={{
                        display: "inline-block",
                        width: 10,
                        height: 10,
                        background: "#FFC107",
                        borderRadius: "50%",
                        marginRight: 8,
                      }}
                    ></span>
                    Pending
                  </div>

                  <div className="fw-semibold">
                    <span
                      style={{
                        display: "inline-block",
                        width: 10,
                        height: 10,
                        background: "#F44336",
                        borderRadius: "50%",
                        marginRight: 8,
                      }}
                    ></span>
                    Cancelled
                  </div>
                </div>
              </div>

              {/* Bottom Summary */}

              <div className="d-flex justify-content-between mt-4 text-center">
                <div className="p-2 rounded bg-light flex-fill me-2">
                  <div className="fw-bold text-success">Completed</div>
                  <div className="fw-semibold text-success">60%</div>
                </div>

                <div className="p-2 rounded bg-light flex-fill me-2">
                  <div className="fw-bold text-warning">Pending</div>
                  <div className="fw-semibold text-warning">25%</div>
                </div>

                <div className="p-2 rounded bg-light flex-fill">
                  <div className="fw-bold text-danger">Cancelled</div>
                  <div className="fw-semibold  text-danger">15%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Top Vendors by Spend */}

        <div className="col-md-4">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              <h6 className="fw-bold mb-3">Top Vendors by Spend</h6>

              <ResponsiveContainer width="100%" height={200}>
                <BarChart
                  data={topVendorsData}
                  layout="vertical"
                  margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
                >
                  <XAxis type="number" hide />
                  <YAxis
                    type="category"
                    dataKey="name"
                    width={100}
                    tick={{ fontSize: 12 }}
                  />
                  <Tooltip formatter={(value) => `₹${value}`} />

                  <Bar
                    dataKey="amount"
                    fill="#6c5ce7"
                    radius={[0, 6, 6, 0]}
                    barSize={12}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* TABLES */}

      <div className="row g-3">
        {/* Recent Vendors */}

        <div className="col-md-4">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Recent Vendors</h6>
                <a href="#" className="small text-primary">
                  View All
                </a>
              </div>

              {/* Table */}
              {/* <table
                className="table align-middle"
                style={{ marginBottom: "1.4rem" }}
              > */}

              <div className="table-responsive">
                <table
                  className="table align-middle text-nowrap"
                  style={{ marginBottom: "1.4rem" }}
                >
                  <thead>
                    <tr>
                      <th className="fw-semibold">Vendor</th>
                      <th className="fw-semibold">Category</th>
                      <th className="fw-semibold">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {recentVendors.map((v, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #f1f1f1" }}>
                        <td className="small">{v.vendor}</td>
                        <td className="small">{v.category}</td>
                        <td className="small">
                          {v.status === "Approved" ? (
                            <span className="text-success fw-semibold">
                              ✓ Approved
                            </span>
                          ) : (
                            <span className="text-warning fw-semibold">
                              ⏳ Pending
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Purchase Orders */}

        <div className="col-md-5">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Top Purchase Orders</h6>
                <a href="#" className="small text-primary">
                  View All
                </a>
              </div>

              {/* Table */}
              {/* <table
                className="table  align-middle "
                style={{ marginBottom: "1.4rem" }}
              > */}
              <div className="table-responsive">
                <table
                  className="table align-middle text-nowrap"
                  style={{ marginBottom: "1.4rem" }}
                >
                  <thead>
                    <tr>
                      <th className="fw-semibold ">PO Number</th>
                      <th className="fw-semibold ">Vendor</th>
                      <th className="fw-semibold ">Amount</th>
                      <th className="fw-semibold ">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {purchaseOrders.map((o, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #f1f1f1" }}>
                        <td className="small">{o.po}</td>

                        <td className="small">{o.vendor}</td>

                        <td className="small fw-semibold">{o.amount}</td>

                        <td className="small">
                          {o.status === "Completed" && (
                            <span
                              className="px-2 py-1 rounded-pill"
                              style={{
                                background: "#e6f4ea",
                                color: "#34a853",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                            >
                              Completed
                            </span>
                          )}

                          {o.status === "Pending" && (
                            <span
                              className="px-2 py-1 rounded-pill"
                              style={{
                                background: "#fff4e5",
                                color: "#f4a100",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                            >
                              Pending
                            </span>
                          )}

                          {o.status === "Cancelled" && (
                            <span
                              className="px-2 py-1 rounded-pill"
                              style={{
                                background: "#fdecea",
                                color: "#ea4335",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                            >
                              Cancelled
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Alerts */}

        <div className="col-md-3">
          <div className="card shadow-sm border-0">
            <div className="card-body pb-2.5 pt-3">
              <div className="d-flex justify-content-between mb-3">
                <h6 className="fw-bold">Alerts</h6>

                <a href="#" className="small text-primary">
                  View All
                </a>
              </div>

              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <FaBell className="text-warning me-2" />

                  <span className="fw-semibold small">
                    5 Vendors waiting for approval
                  </span>

                  <div className="text-muted small">25 mins ago</div>
                </li>

                <li className="mb-2">
                  <FaBell className="text-warning me-2" />
                  <span className="fw-semibold small">
                    3 Purchase Orders overdue
                  </span>

                  <div className="text-muted small">1 hour ago</div>
                </li>

                <li>
                  <FaBell className="text-warning me-2" />

                  <span className="fw-semibold small">
                    2 Products below stock limit
                  </span>
                  <div className="text-muted small">2 hours ago</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
